import ApiService from "@/api";
import { get } from "lodash";

// initial state
const state = () => ({
    loading: false,
    list: []
});

// getters
const getters = {};

// actions
const actions = {
    getCategories(context) {
        const { commit, rootState } = context;
        commit("setLoading", true);
        let url = `/wp-json/wp/v2/hotel_categories`;
        if (get(rootState, "app.lang") === "en") {
            url = `/en/wp-json/wp/v2/hotel_categories`;
        }
        return new Promise(resolve => {
            ApiService.get(url)
                .then(({ data }) => {
                    commit("setCategories", data);
                    commit("setLoading", false);
                    resolve(data);
                })
                .catch(() => {
                    commit("setLoading", false);
                });
        });
    }
};

// mutations
const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setCategories(state, data) {
        state.list = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
